import { createEntityAdapter } from '@reduxjs/toolkit';
import { sortDatetimeIncrease } from '../../../utils/dates_comparer';
import { Answer } from '../../../types';

export const answersAdapter = createEntityAdapter<Answer>({
  sortComparer: (answerA, answerB) =>
    sortDatetimeIncrease(answerA.created_at, answerB.created_at),
});
export const answersInitialState = answersAdapter.getInitialState();
